import {z} from 'zod';

const emptyToUndefined = val => {
  if (typeof val === 'string' && val.trim() === '') return undefined;
  return val;
};

const requiredNumber = () =>
  z.preprocess(
    emptyToUndefined,
    z
      .number({
        required_error: 'Ce champ est requis',
        invalid_type: 'Ce champ est requis'
      })
      .int()
      .nonnegative()
  );

const requiredStringArray = () => z.array(z.string()).min(1, 'Ce champ est requis');

export const officeInformationSchema = z.object({
  dentistCount: requiredNumber(),
  collabDentistCount: requiredNumber(),
  chairsideAssistantCount: requiredNumber(),
  surfaceSqm: requiredNumber(),

  managementSoftware: requiredStringArray(),

  hasSalesAssistant: z.boolean(),
  hasSecretarialAssistant: z.boolean(),
  hasEmployedProsthetist: z.boolean(),

  chairCount: requiredNumber(),

  hasRadio2d: z.boolean(),
  hasRadio3d: z.boolean()
});
